import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BurgerIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M2 6.75A4.75 4.75 0 0 1 6.75 2h2.5A4.75 4.75 0 0 1 14 6.75a.25.25 0 0 1-.25.25H2.25A.25.25 0 0 1 2 6.75ZM2.5 8.5A.5.5 0 0 0 2 9v1a.5.5 0 0 0 .5.5h4.586a1 1 0 0 1 .707.293l1.566 1.566a.2.2 0 0 0 .282 0l1.566-1.566a1 1 0 0 1 .707-.293H13.5a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5h-11Z"
		/>
		<path
			fill="currentColor"
			d="M7.674 12.088A.3.3 0 0 0 7.462 12h-4.89a.571.571 0 0 0-.572.571C2 13.361 2.64 14 3.429 14h9.142c.79 0 1.429-.64 1.429-1.429a.571.571 0 0 0-.571-.571h-1.89a.3.3 0 0 0-.213.088l-.978.978a1.2 1.2 0 0 1-1.697 0l-.977-.978Z"
		/>
	</svg>
))
